// Meta Pixel — loaded only on the FMDO ads funnel routes, mirroring the
// original index.html / plan.html snippets.
import { META_PIXEL_ID } from "./data";

export function loadMetaPixel() {
  if (window.fbq) {
    window.fbq("track", "PageView");
    return;
  }
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
}

export function fbqTrack(event, params) {
  if (typeof window.fbq === "function") window.fbq("track", event, params);
}
